import { render, staticRenderFns } from "./BrandLayout.vue?vue&type=template&id=5a7c8638&scoped=true&"
import script from "./BrandLayout.vue?vue&type=script&lang=js&"
export * from "./BrandLayout.vue?vue&type=script&lang=js&"
import style0 from "./BrandLayout.vue?vue&type=style&index=0&id=5a7c8638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c8638",
  null
  
)

export default component.exports